import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import EventItem from './event-item';
import * as channels from '../../config/constants/channel';
import * as TrackingActions from '../../config/constants/tracking-actions';
import PhoneMask from '../../masks-and-validators/phone';

var selectDetails = function selectDetails(channel, t) {
  switch (channel.channel) {
    case channels.SMS:
      return t('EVENT_CHANNEL_SMS_SELECTED', {
        phone: PhoneMask.mask(channel.data.phone)
      });

    case channels.MESSENGER:
      return t('EVENT_CHANNEL_MESSENGER_SELECTED');

    default:
      return '';
  }
};

export default function ChannelItem(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var description = props.channel.enabled === false ? t('NO_NOTIFICATIONS') : t('EVENT_CHANNEL_SELECTED');
  var details = props.channel.enabled === false ? t('EVENT_NO_CHANNEL_SELECTED') : selectDetails(props.channel, t);
  return /*#__PURE__*/_jsx(EventItem, {
    actions: [props.channel.channel ? TrackingActions.CHANGE_CHANNEL : TrackingActions.SELECT_CHANNEL],
    date: 0,
    code: 0,
    id: "",
    description: description,
    details: details,
    disableConnector: props.disableConnector,
    disableBottomSpacer: props.disableBottomSpacer,
    isFirst: props.isFirst,
    isLast: props.isLast
  });
}